"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskListFeature = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("../../components");
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const Shared_1 = require("../../components/Shared");
const logger_1 = require("../../logger");
const hooks_1 = require("../../features/Timecard/hooks");
const BIAnalytics_1 = __importDefault(require("../../utils/BIAnalytics/BIAnalytics"));
const TaskListFeature = ({ featureGates = {
    isPunchCorrStatusV1Enabled: false,
    isDeleteDupePunchEnabled: false,
    isPunchCorrectionEnabled: false,
    isPunchCorrStatusEnabled: false,
    isAnomalySearchEnabled: false,
    isATPlusTemporalRoutingEnabled: false
} }) => {
    (0, react_1.useEffect)(() => {
        BIAnalytics_1.default.arriveAtTaskList();
    }, []);
    const taskListFeatureGates = {
        isPunchCorrStatusV1Enabled: featureGates.isPunchCorrStatusV1Enabled,
        isDeleteDupePunchEnabled: featureGates.isDeleteDupePunchEnabled,
        isPunchCorrectionEnabled: featureGates.isPunchCorrectionEnabled,
        isPunchCorrStatusEnabled: featureGates.isPunchCorrStatusEnabled,
        isAnomalySearchEnabled: featureGates.isAnomalySearchEnabled,
        isATPlusTemporalRoutingEnabled: featureGates === null || featureGates === void 0 ? void 0 : featureGates.isATPlusTemporalRoutingEnabled
    };
    const { isLoading, taskListGroups, currentPayPeriod } = (0, hooks_1.useGetTaskList)(taskListFeatureGates, true);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.TASK_LIST.COUNT,
            latencyMetricName: logger_1.METRICS.TASK_LIST.LATENCY
        },
        isComponentLoaded: !isLoading
    });
    (0, logger_1.useLogAppLatencyCF)('AtoZTaskList');
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null,
        react_1.default.createElement(Shared_1.NativeAutoScrollProvider, null,
            react_1.default.createElement(components_1.SpinnerOverlay, { isLoading: isLoading },
                react_1.default.createElement(components_1.TaskList, { taskListGroups: taskListGroups, currentPayPeriod: currentPayPeriod, isAnomalySearchEnabled: featureGates.isAnomalySearchEnabled })))));
};
exports.TaskListFeature = TaskListFeature;
